import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import {
  Button,
  Iconography,
  IconographySizes,
} from "@hid-galaxy-ui/galaxy-react";
import "../../unsaved-changes/UnsavedChangesModal.scss";

type Props = {
  open: boolean;
  benefitName: string;
  isDeleting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteBenefitLogModal: React.FC<Props> = ({
  open,
  benefitName,
  isDeleting = false,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="bl-unsaved-modal bl-delete-log-modal">
        <header className="bl-unsaved-modal-header">
          <div className="bl-unsaved-heading">
            <span className="bl-unsaved-icon" aria-hidden="true">
              <Iconography
                icon="circleExclamation"
                size={IconographySizes.Small}
              />
            </span>
            <h3>Delete benefit log?</h3>
          </div>
        </header>
        <DialogContent className="bl-unsaved-modal-content">
          <p>
            Are you sure you want to delete{" "}
            <strong>&quot;{benefitName || "this benefit log"}&quot;</strong>?
            This action cannot be undone.
          </p>
          <div className="bl-delete-warning-box" role="alert">
            <Iconography
              icon="circleExclamation"
              size={IconographySizes.Medium}
            />
            <div>
              <h4>Warning notification</h4>
              <p>
                Deleting this benefit log will permanently remove the entry and
                any attached files.
              </p>
            </div>
          </div>
        </DialogContent>
        <footer className="bl-unsaved-modal-footer">
          <Button
            variant="secondary"
            label="CANCEL"
            onClick={onClose}
            disabled={isDeleting}
          />
          <Button
            variant="primary"
            label={isDeleting ? "DELETING..." : "DELETE"}
            onClick={onConfirm}
            disabled={isDeleting}
          />
        </footer>
      </div>
    </Dialog>
  );
};

export default DeleteBenefitLogModal;
